import type { ComponentType } from "react";

import ReturnNotePdfHistoryComponent from "./ReturnNotePdfHistory.jsx";

const ReturnNotePdfHistory = ReturnNotePdfHistoryComponent as ComponentType<any>;
export default ReturnNotePdfHistory;
